import { ActiveSorts } from "@/shared/components/ActiveFilters";
import { TableCounter } from "./TableCounter";
import type { TableTopBarProps } from "../types";

export const TableTopBar = ({
  isLoading,
  counterType,
  counterSize,
  metadata,
  activeSorts,
  onRemoveSort,
  columnsSelector,
  toolbarActions,
  showTotalAmount = false,
  hideCounter = false,
}: TableTopBarProps) => {
  if (hideCounter && activeSorts.length === 0 && !columnsSelector && !toolbarActions) return null;

  return (
    <div className="flex items-center justify-between mb-2">
      {hideCounter
        ? <div />
        : (
          <TableCounter
            isLoading={isLoading}
            counterType={counterType}
            size={counterSize}
            metadata={metadata}
            showTotalAmount={showTotalAmount}
          />
        )}

      <div className="flex items-center gap-2">
        {activeSorts.length > 0 && <ActiveSorts sorts={activeSorts} onRemoveSort={onRemoveSort} />}
        {toolbarActions}
        {columnsSelector}
      </div>
    </div>
  );
};
